import ReactDOM from "react-dom/client";
import dayjs from "dayjs";
import "styles/index.css";
import utc from "dayjs/plugin/utc";
import * as Sentry from "@sentry/react";
import isToday from "dayjs/plugin/isToday";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import App from "app/App";
import Constants from "common/constant";
import { insideInstalledApp } from "common/utils";
import i18n from "features/shared/i18n";

dayjs.extend(utc);
dayjs.extend(isToday);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

// 2026-03 のリファクタ（#39）で useInitApp.tsx ごと消えていたのを戻す。
// release は CI が作る Sentry のリリース（<環境>-ver<major>.<minor>.<run_number>）と同じ名前にする。
Sentry.init({
  dsn: Constants.sentryDSN,
  integrations: [Sentry.captureConsoleIntegration({ levels: ["error"] })],
  tracesSampleRate: 0.2,
  environment: Constants.sentryEnv,
  release: `${Constants.sentryEnv}-ver${Constants.major}.${Constants.minor}.${Constants.buildNumber}`,
});

i18n.locale = "ja";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deferredPrompt?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ReactNativeWebView?: any;
    parentsAppHostRegionCode?: string;
    parentsAppHostLanguageCode?: string;
    parentsAppPlatform?: string;
    parentsAppVersion?: string;
    parentsBuildVersion?: string;
  }
}

if (insideInstalledApp()) {
  window.resizeBy(1024 - window.innerWidth, 768 - window.innerHeight);
}
